module.exports = __webpack_public_path__ + "static/media/folder.01e6ebf4.svg";